// Advanced enquiry search filters, shared by the advanced search tab and the dashboard tiles that
// deep-link into it. URL params are namespaced so they never collide with the basic tab.
export const ADVANCED_PARAM = {
	enquiryNumber: 'enq',
	familyName: 'fn',
	childName: 'cn',
	contactName: 'ctn',
	phone: 'ph',
	mobile: 'mob',
	email: 'em',
	centreId: 'ctrid',
	centreName: 'ctr',
	from: 'hfrom',
	to: 'hto',
	childDob: 'dob',
	status: 'st',
	source: 'src',
	holdState: 'hold',
	tourWindow: 'tour',
	hasUnread: 'unread',
	hasFailedCommunications: 'failed',
	hasDuplicates: 'dups',
	noCentre: 'nocentre',
	hasCentre: 'hascentre',
	// Inverted: "Show only my centres" defaults on, so only the unticked state is written ('0').
	myCentresOnly: 'mine',
	requireCompletedEnrolment: 'enrolled',
	includeClosed: 'includeClosed',
	page: 'hpage',
};

export const ADVANCED_FLAG_FIELDS = [
	'hasUnread',
	'hasFailedCommunications',
	'hasDuplicates',
	'noCentre',
	'hasCentre',
	'requireCompletedEnrolment',
	'includeClosed',
];

export const ADVANCED_SELECT_FIELDS = ['holdState', 'tourWindow'];
export const ADVANCED_MULTI_SELECT_FIELDS = ['status', 'source'];

// Dashboard "attention" flags rendered as a group in the advanced form.
export const ATTENTION_FLAGS = ['hasUnread', 'hasFailedCommunications', 'hasDuplicates', 'noCentre', 'hasCentre'];

// Values are the API's status codes / enum names.
export const STATUS_OPTIONS = [
	{ value: 'Enquired', label: 'New', order: 1 },
	{ value: 'Engaged', label: 'Engaged', order: 2 },
	{ value: 'Touring', label: 'Touring', order: 3 },
	{ value: 'Pending', label: 'Pending outcome', order: 4 },
	{ value: 'Waitlisted', label: 'Waitlisted', order: 5 },
	{ value: 'Enrolling', label: 'Enrolling', order: 6 },
	{ value: 'Completed', label: 'Completed', order: 7 },
	{ value: 'Cancelled', label: 'Cancelled', order: 8 },
];

export const HOLD_OPTIONS = [
	{ value: 'NotOnHold', label: 'Not on hold', order: 1 },
	{ value: 'OnHold', label: 'On hold', order: 2 },
	{ value: 'OffHoldTomorrow', label: 'Off-hold tomorrow', order: 3 },
	{ value: 'OffHoldThisWeek', label: 'Off-hold this week', order: 4 },
];

export const TOUR_OPTIONS = [
	{ value: 'Today', label: 'Today', order: 1 },
	{ value: 'ThisWeek', label: 'This week', order: 2 },
	{ value: 'NextWeek', label: 'Next week', order: 3 },
	{ value: 'RequiringFollowUp', label: 'Requiring follow-up', order: 4 },
];

export const FLAG_LABELS = {
	hasUnread: 'Unread messages',
	hasFailedCommunications: 'Failed comms (7 days)',
	hasDuplicates: 'Potential duplicates',
	noCentre: 'No centre',
	hasCentre: 'Centre attached',
	requireCompletedEnrolment: 'Has completed enrolment',
	includeClosed: 'Include closed',
};

export const optionLabel = (options, value) => options.find((option) => option.value === value)?.label ?? value;

// Returns `value` only when it is one of `options` (guards hand-edited URLs), otherwise ''.
export const optionValue = (options, value) => (options.some((option) => option.value === value) ? value : '');

export const SELECT_OPTIONS = { status: STATUS_OPTIONS, holdState: HOLD_OPTIONS, tourWindow: TOUR_OPTIONS };

// `/enquiries?tab=advanced&...` with the given form fields applied. Flags are written as '1';
// empty values are omitted. `myCentresOnly` defaults on, so only `false` is written. The
// advanced tab runs this search on load.
export function advancedSearchUrl(filters = {}) {
	const params = new URLSearchParams({ tab: 'advanced' });
	Object.entries(filters).forEach(([field, value]) => {
		const param = ADVANCED_PARAM[field];
		if (field === 'myCentresOnly') {
			if (value === false) params.set(param, '0');
			return;
		}
		if (!param || value == null || value === '' || value === false) return;
		if (ADVANCED_MULTI_SELECT_FIELDS.includes(field)) {
			(Array.isArray(value) ? value : [value]).forEach((item) => {
				if (item) params.append(param, item);
			});
			return;
		}
		params.set(param, value === true ? '1' : String(value));
	});
	return `/enquiries?${params.toString()}`;
}
